import type { Locale } from "../types/content";

export type LeadType = "moldova_project" | "israel_technology" | "institution" | "generic";

export type LeadSubmission = {
  leadType: LeadType;
  locale: Locale;
  sourcePage: string;
  consent: boolean;
  startedAt: number;
  honeypot?: string;
  data: Record<string, unknown>;
  files?: File[];
};

export async function submitLead(submission: LeadSubmission) {
  if (import.meta.env.DEV && !import.meta.env.VITE_API_BASE_URL) {
    await new Promise((resolve) => window.setTimeout(resolve, 500));
    return { ok: true, id: crypto.randomUUID(), localPreview: true };
  }

  const formData = new FormData();
  formData.append("payload", JSON.stringify({ ...submission, files: undefined }));
  submission.files?.forEach((file) => formData.append("files", file));

  const baseUrl = import.meta.env.VITE_API_BASE_URL || "";
  const response = await fetch(`${baseUrl}/api/leads`, {
    method: "POST",
    body: formData
  });

  if (!response.ok) {
    throw new Error("lead_submission_failed");
  }

  return response.json();
}
